module.exports = new __parcel__URL__("parrot.cde4168a.svg").toString();